import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  REDIRECT_PAGE_NOTIFIER_ID
} from '../modules/security/service/auth.service';
import { NotifierService } from '../shared/services/notifier.service';

@Component({
  selector: 'admin-portal-app',
  templateUrl: './console/app-js/app/app.component.html'
})
export class AppComponent {
  constructor(
    private router: Router,
    private notifierService: NotifierService,
    private authService: AuthService
  ) {
    this.callbackRedirectListener();
  }

  /**
   * This functions listens whenever the user has been redirected from a login callback.
   * Redirects user to it's home page.
   */
  private callbackRedirectListener(): void {
    this.notifierService.on(REDIRECT_PAGE_NOTIFIER_ID, event => {
      this.router.navigate([event.page]);
    });
  }
}
